import { DashboardHomeComponent } from './core/components/dashboard-home/dashboard-home.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EngineComponent } from './core/components/engine/engine.component';
import {
  CreateAutoTrainingCodeComponent
} from './core/components/training-management/create-auto-training-code/create-auto-training-code.component';
import {
  EditAutoTrainingCodeComponent
} from './core/components/training-management/edit-auto-training-code/edit-auto-training-code.component';
import { EmailInviteComponent } from './core/components/training-management/email-invite/email-invite.component';
import { EmailSentComponent } from './core/components/training-management/email-sent/email-sent.component';
import {
  InactiveAutoTrainingCodeComponent
} from './core/components/training-management/inactive-auto-training-code/inactive-auto-training-code.component';
import { ReportingComponent } from './core/components/training-management/reporting-training/reporting/reporting.component';
import { SuperAdminComponent } from './core/components/training-management/super-admin/super-admin.component';
import {
  TrainingManagementHomeComponent
} from './core/components/training-management/training-management-home/training-management-home.component';
import { SuperAdminAuthGuardService } from './core/services/super-admin-auth-guard.service';


const appRoutes: Routes = [
  {
    path: 'home',
    component: TrainingManagementHomeComponent
  },
  {
    path: 'create-autotraining',
    component: CreateAutoTrainingCodeComponent
  },
  {
    path: 'edit-autotraining',
    component: EditAutoTrainingCodeComponent
  },
  {
    path: 'email-invite',
    component: EmailInviteComponent
  },
  {
    path: 'email-sent',
    component: EmailSentComponent
  },
  {
    path: 'inactive-autotraining',
    component: InactiveAutoTrainingCodeComponent
  },
  {
    path: 'reporting',
    component: ReportingComponent
  },
  {
    path: 'super-admin',
    component: SuperAdminComponent,
    canActivate: [SuperAdminAuthGuardService]
  },
  {
    path: 'dashboard',
    component: DashboardHomeComponent
  },
  {
    path: '',
    component: TrainingManagementHomeComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
  providers: [SuperAdminAuthGuardService],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/app-routing.module.ts